export default __webpack_public_path__ + "static/media/placeholder_dummy2016-kunstgalerie01-mobile-de.d0c9b502.png";